import { Option } from '@spike/model';
import {
    RecurringSeriesConflictPreference,
    RecurringSeriesOccurrence,
    ScheduleFrequencyId
} from '@spike/new-booking-model';
import { Moment } from 'moment-timezone';

export type RecurrenceEnd =
    | { type: 'never' }
    | { type: 'after'; bookings: number }
    | { type: 'on_date'; date: Moment | undefined };

export type ConflictPreference = RecurringSeriesConflictPreference;

export interface RecurrenceFrequencyOption {
    id: ScheduleFrequencyId;
    label: string;
}

export interface RecurringSeriesConfig {
    frequency: RecurrenceFrequencyOption | undefined;
    end: RecurrenceEnd;
    conflicts: ConflictPreference;
}

export const RECURRING_SERIES_MAX_HORIZON_YEARS = 2;

export const getFrequencyOptions = (scheduleFrecuency: Array<Option<string>>): Array<RecurrenceFrequencyOption> =>
    scheduleFrecuency.map(option => ({
        id: option.id as ScheduleFrequencyId,
        label: option.name
    }));

export const DEFAULT_RECURRING_SERIES_CONFIG: RecurringSeriesConfig = {
    frequency: undefined,
    end: { type: 'never' },
    conflicts: 'create_anyway'
};

export const RECURRING_SERIES_OCCURRENCE_STATUS_LABELS: Record<RecurringSeriesOccurrence['status'], string> = {
    created: 'Booked',
    draft: 'Draft',
    needs_review: 'Needs Review',
    skipped: 'Skipped',
    failed: 'Failed',
    exception: 'Exception',
    protected: 'Protected',
    protected_exception: 'Protected Exception',
    canceled: 'Canceled',
    unknown: 'Unknown'
};

export const CONFLICT_PREFERENCE_LABELS: Record<RecurringSeriesConflictPreference, string> = {
    create_anyway: 'Create Anyway',
    next_available: 'Next Available Time',
    do_not_create: "Don't Create"
};

export const RECURRING_SERIES_CREATING = 'in_progress';
export const RECURRING_SERIES_COMPLETED = 'completed';

export type SeriesCreationPhase = 'creating' | 'created' | 'failed';

export const getSeriesCreationPhase = (status: string): SeriesCreationPhase => {
    if (status === RECURRING_SERIES_CREATING) {
        return 'creating';
    }
    if (status === RECURRING_SERIES_COMPLETED) {
        return 'created';
    }
    return 'failed';
};
